import React, { useEffect } from 'react'
import { Button } from '../../../components/Button/Button'
import { Col, Row } from 'react-bootstrap'
import { useNotification } from '../hooks/useNotification'
import { useLogger } from '../../../components/Logger/hooks/useLogger'
import { useCookies } from 'react-cookie'

const NotificationMessage: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Row className='justify-content-start align-items-center px-4 py-2'>{children}</Row>
)
const HALF_YEAR_IN_SECONDS = 60 * 60 * 24 * 30 * 6
export const NotificationManager: React.FC = () => {
  const { status, requestPermission } = useNotification()
  const logger = useLogger()
  const [cookies, setCookie] = useCookies(['hideWebNotificationAlert'])
  const closeNotificationAlert = () => {
    setCookie('hideWebNotificationAlert', true, { path: '/', maxAge: HALF_YEAR_IN_SECONDS })
  }

  useEffect(() => {
    if (status === 'denied') {
      logger.info('[NotificationManager] Notifications are blocked by the user.')
    }
  }, [status, logger])

  if (status === 'denied' && !cookies.hideWebNotificationAlert) {
    return (
      <NotificationMessage>
        <Col xs='auto' className='px-0'>
          <div className='d-flex align-items-center gap-2 zocks-text-dark-green'>
            <i className='bi bi-bell'></i>
            You've blocked notifications. If you change your mind, you can update your browser settings.
          </div>
        </Col>

        <Col className='d-flex align-items-center justify-content-end'>
          <i onClick={closeNotificationAlert} className='bi bi-x-lg'></i>
        </Col>
      </NotificationMessage>
    )
  }

  return status === 'default' && !cookies.hideWebNotificationAlert ? (
    <NotificationMessage>
      <Col xs='auto' className='px-0'>
        <div className='d-flex align-items-center gap-2 zocks-text-dark-green'>
          <i className='bi bi-bell'></i>
          Don't let meetings run idle. Get notified if no one is speaking, even when you're away from this tab.
        </div>
      </Col>
      <Col xs='auto'>
        <Button variant='cyanGhostButton' className='button-small' onClick={requestPermission}>
          Enable Notifications
        </Button>
      </Col>
      <Col className='d-flex align-items-center justify-content-end'>
        <i onClick={closeNotificationAlert} className='bi bi-x-lg'></i>
      </Col>
    </NotificationMessage>
  ) : null
}
